<template>
  <div>
    <el-card v-loading="loading" shadow="never">
      <div style="padding: 20px 20px">
        <div v-if="editModel">
          <el-form
            ref="form"
            :size="$xUISize"
            :model="editModel"
            :rules="editRules"
            @submit.native.prevent
            label-width="auto"
            label-position="top"
          >
            <el-form-item label="经营企业" prop="companyName">
              <div v-if="editModel.companyName">
                <span> {{ editModel.companyName }}</span>
              </div>
              <div v-else>
                <span style="color: #ff0000">请先完善门店经营企业信息</span>
              </div>
              <div v-if="editModel.vetCompanyId">
                <span> 兽药经营企业编号：{{ editModel.vetCompanyId }}</span>
              </div>
              <div>
                <span style="color: #919191">
                  * 注意：兽药经营需取得兽药经营许可证方可开展
                </span>
              </div>
            </el-form-item>
            <template v-if="!!editModel.companyName">
              <el-form-item label="兽药追溯账号" prop="vetUserid">
                <el-input
                  maxlength="128"
                  v-model="editModel.vetUserid"
                  placeholder="请输入兽药追溯账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="兽药追溯密码" prop="vetPassword">
                <el-input
                  maxlength="128"
                  v-model="editModel.vetPassword"
                  placeholder="请输入兽药追溯密码"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="margin-top: 30px"
                  :loading="editSubmit"
                  @submit.native.prevent
                  @click="submitClick"
                >
                  提交绑定
                </el-button>
              </el-form-item>
            </template>
          </el-form>
        </div>
        <el-empty
          v-else-if="!loading"
          :description="errorMsg || '正在加载内容'"
          :image-size="100"
        >
          <el-button v-if="errorMsg" @click="fetchModel" size="small">
            重新加载
          </el-button>
        </el-empty>
      </div>
    </el-card>
  </div>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}
</style>

<script>
import baiduPos from '../../../../components/baiduPos.vue';

export default {
  components: {
    baiduPos
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        companyName: [
          {
            required: true,
            validator: (rule, value, callback) => {
              callback();
            },
            trigger: "change",
          },
        ],
        vetUserid: [
          {
            required: true,
            message: "请输入兽药追溯账号",
            trigger: "change",
          },
        ],
        vetPassword: [
          {
            required: true,
            message: "请输入兽药追溯密码",
            trigger: "change",
          },
        ]
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          this.requestApi("biz.customer.store.info.bindVet", this.editModel, {
            showError: true
          }).then((resp) => {
            this.success("保存成功");
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
    },
    fetchModel() {
      // 编辑
      this.errorMsg = null;
      this.loading = true;
      this.requestApi("biz.customer.store.info.detail", {
        guid: this.pageParams.guid
      }).then((resp) => {
        this.editModel = resp.data;
        this.handleModel();
      }).catch((err) => {
        this.errorMsg = (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
